module.exports = __webpack_public_path__ + "media/images/partners/ukf-e92071b33a51d548b70a88d689d99318.png";